// import log from "cslog";
import React from "react";
// import { GOOGLE_FONTS } from "../../customize/ComplexOptions";
import { decodeStyle, useExport } from "../../../../junctionAbs";
import CanvasFreeView from "./CanvasFreeView";
import styles from "./styles/BookPage.module.css";
import log from "cslog";
// import { resolveClipPath } from "../../../../../_helper/image";
import { resolveClipPath } from "../../../../junctionAbs";
import {
    usePageDbConfig,
    fillableAllState,
    gsState,
    // useFillableOnePage,
} from "../../../../db";
// import { useContent } from "../../../../../dynamicdata/query";
import { useContent } from "../../../../junctionAbs";
import { useAtom } from "jotai";
import ActionUI from "../../../responsive/elements_responsive_static/special/ActionUI";

const BookPage = ({
    id,
    db,
    globalDb,
    index,
    device,
    gs,
    dydb,
    ctx,
    globalConfig,
    bookLayout,
    applyGlobal,
    title,
    page_filled_data = {},
}) => {
    const gdata = globalDb["globalPage"];
    const data = db[id];

    const dims = bookLayout.pageSize.value;
    const { boxRef, exhome } = useExport(title, dims);

    const [dbc, setDBC] = usePageDbConfig(id);

    const [filled_data, _] = useAtom(fillableAllState);

    log.d(id, "page_id in BPP");

    const [gs_data, __] = useAtom(gsState);

    const all_gs = {
        ...gs,
        config: {
            ...(gs?.config || {}),
            ...gs_data?.config,
            // secondryColor: "hotpink"
        },
    };

    const globalConfigD = decodeStyle(globalConfig, all_gs);

    const inputs = {
        organization: ctx?.organization,
        person: ctx?.person,
    };

    log.d(dydb, "dydb in BPP");

    const content = useContent(
        dydb,
        dbc,
        {},
        // ctx?.organization,
        inputs,
        ctx,
        // filled_data
        {
            ...filled_data,
            ...page_filled_data,
        }
        // {
        //     fact: {
        //         fact: "Hello fact",
        //         source: "Hello source",
        //     },
        // }
    );
    const all_content = {
        ...content,
        gv: {
            status: "success",
            isSuccess: true,
            // data: globalVariables,
            // data: gv,
            data: dydb?.gv || {},
        },
    };
    log.d(all_content, "All Content in BPP");

    let padding = bookLayout.padding.params;
    if (bookLayout.padding.type === "single") {
        padding = {
            top: bookLayout.padding.params,
            bottom: bookLayout.padding.params,
            left: bookLayout.padding.params,
            right: bookLayout.padding.params,
        };
    }

    // useEffect(() => {
    //     if (GOOGLE_FONTS.includes(globalConfigD.defaultFontFamily)) {
    //         window.WebFont.load({
    //             google: {
    //                 families: [globalConfigD.defaultFontFamily],
    //             },
    //         });
    //     }
    // }, []);

    // return <h2>Hello BPP</h2>;

    return (
        <div
            style={{
                width: dims.width,
                height: dims.height,
                position: "relative",
                // border: "2px dashed green",
                userSelect: "none",
            }}
        >
            <div
                ref={boxRef}
                id={id}
                name={id}
                style={{
                    width: dims.width,
                    height: dims.height,
                    // boxShadow: "0px 0px 8px 1px rgba(222,222,222,1)",
                    marginTop: 0,
                    position: "absolute",
                    borderRadius: bookLayout.borderRadius?.value,
                    // "*": globalConfig,
                    fontFamily: globalConfigD.defaultFontFamily,
                    background: globalConfigD.pageBackground,
                    backgroundColor: "transparent",
                    clipPath: resolveClipPath(bookLayout.clip),
                }}
                css={
                    {
                        // "*": globalConfig,
                        // fontFamily: globalConfigD.defaultFontFamily,
                        // background: globalConfigD.pageBackground,
                        // background: "yellow",
                    }
                }
            >
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        background: bookLayout.background.value,
                        backgroundPosition: bookLayout?.backgroundPosition,
                        borderRadius: bookLayout.borderRadius?.value,
                        // overflow: "hidden",
                    }}
                >
                    {applyGlobal && (
                        <div className={styles.grid_wrapper}>
                            <div style={{ position: "relative" }}>
                                {gdata.bg.map((item) => {
                                    return (
                                        <CanvasFreeView
                                            key={item}
                                            id={item}
                                            db={globalDb}
                                            width={dims.width}
                                            height={dims.height}
                                            padding={padding}
                                            device={device}
                                            gs={all_gs}
                                            isBg={false}
                                            dydb={all_content}
                                        />
                                    );
                                })}
                                {gdata.childs.map((item) => {
                                    return (
                                        <CanvasFreeView
                                            key={item}
                                            id={item}
                                            db={globalDb}
                                            width={
                                                dims.width
                                                // dims.width -
                                                // padding.left -
                                                // padding.right
                                            }
                                            height={
                                                dims.height
                                                // dims.height -
                                                // padding.top -
                                                // padding.bottom
                                            }
                                            padding={padding}
                                            device={device}
                                            gs={all_gs}
                                            isBg={false}
                                            dydb={all_content}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>

                <div className={styles.grid_wrapper}>
                    <div style={{ position: "relative" }}>
                        {data.bg.map((item) => {
                            return (
                                <CanvasFreeView
                                    key={item}
                                    id={item}
                                    db={db}
                                    width={dims.width}
                                    height={dims.height}
                                    padding={padding}
                                    device={device}
                                    gs={all_gs}
                                    isBg={false}
                                    dydb={all_content}
                                    ctx={ctx}
                                />
                            );
                        })}
                        {data.childs.map((item) => {
                            return (
                                <CanvasFreeView
                                    key={item}
                                    id={item}
                                    db={db}
                                    width={
                                        dims.width
                                        // dims.width -
                                        // padding.left -
                                        // padding.right
                                    }
                                    height={
                                        dims.height
                                        // dims.height -
                                        // padding.top -
                                        // padding.bottom
                                    }
                                    padding={padding}
                                    device={device}
                                    gs={all_gs}
                                    isBg={false}
                                    dydb={all_content}
                                    ctx={ctx}
                                />
                            );
                        })}
                    </div>
                </div>
                {true &&
                    [
                        all_gs.config?.primaryFont,
                        all_gs.config?.secondryFont,
                    ].map((font) => {
                        return (
                            <link
                                key={font}
                                href={`https://fonts.googleapis.com/css2?family=${font}&display=swap`}
                                rel="stylesheet"
                                crossOrigin="anonymous"
                            />
                        );
                    })}
            </div>

            {/* <FreeControlBar />
            <LayersBar /> */}
        </div>
    );
};

export default BookPage;
